export default "__VITE_ASSET__CQd70IY4__"